import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getTransactionApi = createAsyncThunk('gettransactionStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingTransactionDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllClientTransactions`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(transactionDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(transactionDetailClear())
                message.error(error) 
            })
    }
)


const GetTransactionApiSlice = createSlice({
    name: 'Transactiongetapi',
    initialState: {
        transactionData: null,
        loadingtransaction: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
        },
    },
    reducers: {
        gettingTransactionDetail: state => {
            state.loadingtransaction=true
            state.transactionData=null
        },
        transactionDetailResponse: (state, action)=>{
            state.transactionData= action.payload
            state.loadingtransaction= false
        },
        transactionDetailClear: (state)=>{
            state.transactionData= null
            state.loadingtransaction= false
        },
        changeJobDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
    },
})
export const { 
    gettingTransactionDetail, transactionDetailResponse, transactionDetailClear,
    changeJobDetailFilters, setPages
} = GetTransactionApiSlice.actions;
export default GetTransactionApiSlice.reducer;